export { InputConsumer as default } from './InputConsumer';
